import { render, staticRenderFns } from "./HomeRecommend.vue?vue&type=template&id=5b432df0&scoped=true"
import script from "./HomeRecommend.vue?vue&type=script&lang=js"
export * from "./HomeRecommend.vue?vue&type=script&lang=js"
import style0 from "./HomeRecommend.vue?vue&type=style&index=0&id=5b432df0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b432df0",
  null
  
)

export default component.exports